import React from 'react';
import  './button.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft, faPlus } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types';
import { messageService } from '../../../services/subscriberService';

const LoadMore = (props) => {
    return (
        <div className="load_more">
            <button type="button" onClick={props.click}>Load More</button>
        </div>
    )
}
const Approve = (props) => {
    return (
        <button type="button" className="approve" onClick={props.click}>Approve</button>
    )
}
const Reject = (props) => {
    return (
        <button type="button" className="reject" onClick={props.click}>Reject</button>
    )
}

const CustomButton = (props) => {

    const {click,condition,label,clas,icon} = props;
    return(
        <React.Fragment>
            {props.click?
                <button type="button" className = {condition ? (clas || 'activeButton'): 'disableButton'} 
                    onClick = {(e) => {
                        e.preventDefault();
                        if(condition)  {
                            click(e)
                        }
                    }}>
                    {icon? <FontAwesomeIcon icon={faPlus} />: null}
                    {label || 'button'}
                </button>:
                <button  className = {condition ? (clas || 'activeButton'): 'disableButton'} 
                    disabled = {!condition}>
                    {label || 'button'}
                </button>
            }
        </React.Fragment>
    )
}

const CustomButtonWB = (props) => (
    <button type="button" className ={props.class || "customButtonWB"} onClick = {props.click}>
        {props.label || 'back'}
    </button>
)

const SignUpContButton = (props) => {
    return (
        <div className="SignUpContButton">
            {props.showBackward === "1"?
            <FontAwesomeIcon className="back_button" onClick={props.back} icon = { faArrowCircleLeft } />
            : null}
            <button type="submit" 
            disabled={props.invalid || props.loadingStatus} onClick = {props.clicked}
            style={{backgroundColor:props.invalid?'#808080':'#F22B5D',
                    cursor:props.invalid || props.loadingStatus?'default':'pointer',
                    opacity:props.loadingStatus?'0.6':'unset'}}>
                    {props.buttonText}
            </button>
        </div>    
    )
}

const ApproveReject = (props) => {
    return (
        <div className="ApproveReject">
            <Approve click={props.approve}></Approve>
            <Reject click={props.reject}></Reject>
        </div>
    )
}

export const TextButton = props => {
    const { label, className, handleClick,style, invalid, disabled } = props;
    return (
        <button 
            type="button"
            style = {style}
            className={`${className} ${disabled?'disabled':''}`}
            onClick={handleClick}
            disabled={invalid || disabled} 
        >
            {label}
        </button>
    );
}

export const Button = props => {
    const { label, className, handleClick,style, invalid, disabled, type, showAddIcon, addIconName } = props;
    return (
        <React.Fragment>
            {type === 'button'?
                <button 
                    type="button"
                    style = {style}
                    className={`btns ${className} ${invalid || disabled?'disabled':''}`}
                    onClick={e => {
                        e.preventDefault();
                        if(invalid || disabled) {} else if(!messageService.count.length) {
                            handleClick();
                        }
                    }}
                >
                    {showAddIcon && <FontAwesomeIcon icon={addIconName || faPlus} />}
                    {label}
                </button>:
                <button 
                    type={type}
                    style = {style}
                    className={`btns ${className} ${invalid || disabled?'disabled':''}`}
                    disabled={invalid || disabled} 
                >
                    {showAddIcon && <FontAwesomeIcon icon={addIconName || faPlus} />}
                    {label}
                </button>
            }
        </React.Fragment>
    );
}

Button.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    style: PropTypes.object,
    className: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    showAddIcon: PropTypes.bool.isRequired,
    invalid: PropTypes.bool,
    handleClick: PropTypes.func
}

Button.defaultProps = {
    disabled: false,
    invalid: false,
    showAddIcon: false,
    className: 'btns-primary',
    label: 'button',
    type: 'button'
}

export {
    LoadMore,
    Approve,
    Reject,
    SignUpContButton,
    ApproveReject,
    CustomButton,
    CustomButtonWB
};